import { Outlet, useOutletContext } from 'react-router'
import { Footer } from '#app/components/footer'
import { Header } from '#app/components/header'
import { type Theme } from '#app/utils/theme.server'

export default function ExploreCountryLayout() {
	const { theme } = useOutletContext<{ theme: Theme }>()

	return (
		<>
			<div className="flex h-screen flex-col overflow-hidden p-2 md:p-4 lg:p-8">
				<div className="flex-none">
					<Header userPreference={theme} />
				</div>

				<div className="mt-2 flex flex-1 flex-col overflow-hidden">
					<Outlet />
				</div>
			</div>

			<Footer className="py-2 md:py-4 lg:py-8" />
		</>
	)
}
